import { createTheme } from "@mui/material/styles";
import { T, FONT } from "./admin.theme";
// Единая MUI-тема админки: примитивы Refine/MUI (Button, Chip, TextField,
// Select, Menu, Dialog, Tooltip, Paper) наследуют тёмно-золотой стиль макета,
// чтобы не дублировать sx в каждом экране.
export var adminMuiTheme = createTheme({
    palette: {
        mode: "dark",
        primary: { main: T.accent, dark: T.accentHover, light: T.accentBright, contrastText: T.bgPage },
        error: { main: T.danger },
        success: { main: T.success },
        info: { main: T.info },
        background: { default: T.bgPage, paper: T.surface },
        text: { primary: T.textPrimary, secondary: T.textSecondary, disabled: T.textMuted },
        divider: T.border,
    },
    shape: { borderRadius: T.radiusSm },
    typography: {
        fontFamily: FONT.body,
        h1: { fontFamily: FONT.heading },
        h2: { fontFamily: FONT.heading },
        h3: { fontFamily: FONT.heading },
        h4: { fontFamily: FONT.heading },
        h5: { fontFamily: FONT.heading },
        h6: { fontFamily: FONT.heading },
        button: { textTransform: "none", fontWeight: 600 },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: { backgroundImage: "none", backgroundColor: T.surface },
            },
        },
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: {
                root: { borderRadius: T.radiusSm, fontWeight: 600 },
                containedPrimary: {
                    color: T.bgPage,
                    boxShadow: "0 4px 20px ".concat(T.accentGlow),
                    "&:hover": { backgroundColor: T.accentHover },
                },
                outlined: {
                    borderColor: T.border,
                    color: T.textSecondary,
                    "&:hover": { borderColor: T.accent, color: T.accent, backgroundColor: T.accentTint },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: { fontWeight: 600, borderRadius: T.radiusPill },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: T.surface2,
                    borderRadius: T.radiusSm,
                    "& fieldset": { borderColor: T.border },
                    "&:hover fieldset": { borderColor: T.accentTintStrong },
                    "&.Mui-focused fieldset": { borderColor: T.accent },
                },
                input: { color: T.textPrimary },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: { color: T.textMuted, "&.Mui-focused": { color: T.accent } },
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    backgroundColor: T.surface2,
                    border: "1px solid ".concat(T.border),
                    borderRadius: T.radiusSm,
                    marginTop: 6,
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: 13,
                    color: T.textPrimary,
                    "&:hover": { backgroundColor: T.accentTint },
                    "&.Mui-selected": { backgroundColor: T.accentTint, color: T.accent },
                    "&.Mui-selected:hover": { backgroundColor: T.accentTintStrong },
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    backgroundColor: T.surface,
                    border: "1px solid ".concat(T.border),
                    borderRadius: 18,
                    backgroundImage: "none",
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: T.surface2,
                    border: "1px solid ".concat(T.border),
                    color: T.textPrimary,
                    fontSize: 12,
                },
                arrow: { color: T.surface2 },
            },
        },
        MuiCircularProgress: {
            styleOverrides: { root: { color: T.accent } },
        },
    },
});
